<script setup lang="ts">
import { computed } from "vue";

import { getAlmInfo } from "@/backend/read/BackendReader";
import InfoMessage from "@/components/ui/InfoMessage/InfoMessage.vue";

import ActionConfirmModal from "./ActionConfirmModal.vue";

defineProps<{ isDeletable: boolean; almId: string }>();
const emit = defineEmits<{ delete: [] }>();

const almInfo = computed(() => getAlmInfo());
</script>

<template>
  <ActionConfirmModal
    :title="$t('action.deleteSticky', 1)"
    :description="
      isDeletable
        ? $t('action.deleteSticky.description', 1)
        : $t('action.deleteAlmSticky.deletionBlocked', { almName: almInfo.name })
    "
    :primary-label="$t('general.delete')"
    primary-icon="general/delete"
    destructive
    :primary-disabled="!isDeletable"
    @primary="emit('delete')"
  >
    <template v-if="isDeletable" #extra>
      <InfoMessage level="warn" size="small" :icon="almInfo.colorIcon">
        {{ $t("action.deleteAlmSticky.willAlsoBeDeleted", { almId, almName: almInfo.name }) }}
      </InfoMessage>
    </template>
  </ActionConfirmModal>
</template>
